import { defineMessages } from "react-intl";

export const messages = defineMessages({
    migrationTicketsTableHeading: {
        id: "fastshift.dashboard.migration-tickets-table.heading",
        defaultMessage: "Migration tickets",
        description: "Heading of the migration tickets table"
    },
    migrationTicketsTableDescriptionWithAnOrg: {
        id: "fastshift.dashboard.migration-tickets-table.description-with-an-org",
        defaultMessage:
            "Tickets associated with a selected cloud organization.",
        description: "Description of the migration tickets table with an org"
    },
    migrationTicketsTableDescriptionAsNotAnAdmin: {
        id: "fastshift.dashboard.migration-tickets-table.description-as-not-an-admin",
        defaultMessage:
            "Tickets associated with cloud organizations you’re not an admin of.",
        description:
            "Description of the migration tickets table as not an admin"
    },
    migrationTicketsTableDescriptionWithNoOrg: {
        id: "fastshift.dashboard.migration-tickets-table.description-with-no-org",
        defaultMessage: "Tickets not associated with any cloud organization.",
        description: "Description of the migration tickets table with no org"
    },
    migrationTicketsListViewAll: {
        id: "fastshift.dashboard.migration-tickets-list.view-all",
        defaultMessage: "View all tickets",
        description: "Link text to view all migration tickets"
    },
    migrationTicketsListEmptyState: {
        id: "fastshift.dashboard.migration-tickets-list.empty-state",
        defaultMessage: "No migration tickets to show yet.",
        description: "Message displayed when no migration tickets are found"
    },
    migrationTicketsListErrorMessage: {
        id: "fastshift.dashboard.migration-tickets-list.error-message",
        defaultMessage:
            "We’re unable to retrieve the data about your migration progress.",
        description:
            "Error message displayed when migration tickets fail to load"
    }
});
